module.exports = __webpack_public_path__ + "public/files/img/extension.64d3d606.png";